"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var index_1 = require("./index");
var useContext = React.useContext;
exports.default = (function () {
    var _a = useContext(index_1.AppContext), comments = _a.comments, minCommentsLength = _a.minCommentsLength, setComments = _a.setComments, submit = _a.submit;
    var cancel = window.accountApp.settings.cancel;
    return (React.createElement("div", { className: 'padding-4 medium-padding-8' },
        React.createElement("div", { className: 'text-center margin-bottom-12' },
            React.createElement("h3", null, cancel.commentsTitle),
            React.createElement("div", { className: 'divider bg-cornflower-blue margin-vertical-4 margin-horizontal-auto' }),
            React.createElement("div", { className: 'margin-bottom-4', dangerouslySetInnerHTML: { __html: cancel.commentsBody } }),
            React.createElement("textarea", { minLength: minCommentsLength, onChange: function (e) { return setComments(e.target.value); }, placeholder: cancel.commentsPlaceholder, required: true, style: { minHeight: '110px' } })),
        React.createElement("div", { className: 'text-center' },
            React.createElement("button", { className: 'button wisteria', disabled: comments.length < minCommentsLength, id: 'account-finalize-cancel-bundle-btn' // for GA
                , onClick: submit }, cancel.commentsButton))));
});
